import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Input } from 'reactstrap';
import ReactToPrint from 'react-to-print';
import { db } from '../../firebase';
import { updateDoc, doc, getDoc ,setDoc} from "firebase/firestore";
import axios from 'axios';
import logo from '../../images/splash/shop_logo.jpeg';
import { var_api } from '../constant';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Accordion from 'react-bootstrap/Accordion';
import Select from 'react-select';
toast.configure()


class SbBill extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      isOpenOrderEdit:false,
      updatedOrder:null,
      beauticians:[]
    };

  }


  componentDidMount() {
    this.fetchBeauticians();
  }

  handleOpenOrderEdit = (order) => {
    this.setState({isOpenOrderEdit:true, updatedOrder: order})
    console.log('updated order', order, this.state.updatedOrder)
  }


  handleCloseOrderEdit = () => {
    this.setState({isOpenOrderEdit:false})
  }

  fetchBeauticians = async()=> {
    const token = localStorage.getItem('token');
    const headers = {
      Authorization: `${token}`,
  };
      try {
        const response = await axios.get(`${var_api}/api/employee/get-active-employees`, { headers });
        const data = response.data;
        console.log(' fetching data:', data);
        const beaut = data.map(beautician => ({
          value: beautician.id,
          label: beautician.employee_name
        }));
        this.setState({ beauticians: beaut });
        
      } catch (error) {
        console.log('Error fetching data:', error);
        
      }
  }

  handleTimeChange = (event) => {
    const { name, value } = event.target;
    const { service_duration } = this.state.updatedOrder;
    const updatedOrder = { ...this.state.updatedOrder, [name]: value };

    if (name === 'start_time') {
        // Extract hours, minutes, and seconds from the start_time
        const [startHours, startMinutes, startSeconds] = value.split(':').map(Number);

        // Calculate the total duration in minutes and seconds
        const durationHours = Math.floor(service_duration / 60);
        const durationMinutes = service_duration % 60;

        // Calculate the new time by adding duration to start time
        let endHours = startHours + durationHours;
        let endMinutes = startMinutes + durationMinutes;
        let endSeconds = startSeconds || 0;

        // Handle overflow of minutes to hours
        if (endMinutes >= 60) {
            endHours += Math.floor(endMinutes / 60);
            endMinutes = endMinutes % 60;
        }

        // Handle seconds correctly
        endSeconds = (startSeconds || 0).toString().padStart(2, '0');

        // Format end time to ensure two digits for hours, minutes, and seconds
        const formattedEndHours = endHours.toString().padStart(2, '0');
        const formattedEndMinutes = endMinutes.toString().padStart(2, '0');

        // Set the end_time in updatedOrder
        updatedOrder.end_time = `${formattedEndHours}:${formattedEndMinutes}:${endSeconds}`;
    }

    this.setState({ updatedOrder });
}


  
  
  
handleBeauticianChange = (selectedOption) => {
  console.log('Selected beautician:', selectedOption);
  const updatedOrder = {
    ...this.state.updatedOrder,
    employee_id: selectedOption.value,
    beautician: selectedOption.label,
  };
  this.setState({ updatedOrder }, () => {
    console.log('Updated order:', this.state.updatedOrder);
  });
};


  handleSubmit = async () => {
    const { updatedOrder } = this.state;
    console.log('before put', updatedOrder);
    const serviceId = updatedOrder.id; // Use the appropriate ID
    const token = localStorage.getItem('token');
    const data = {
      seat_start_time: updatedOrder.start_time,
      seat_end_time: updatedOrder.end_time,
      employee_id: updatedOrder.employee_id,
      employee_name: updatedOrder.beautician
    };

    try {
      const response = await axios.put(`${var_api}/api/seat_service/put/${serviceId}`, data, {
        headers: {
          Authorization: token
        }
      });
      console.log('Service order updated successfully', response.data);
    } catch (error) {
      console.error('Error updating service order:', error);
    }
  };

  // Function to convert minutes to hours and minutes
convertMinutesToHours = (minutes) => {
  if (!minutes && minutes == 0) return "0h 0m"; 
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  if (hours > 0) {
    return `${hours} hrs ${remainingMinutes} mins`;
  } else {
    return `${remainingMinutes} mins`;
  }
};




  render() {
    const { order } = this.props;
    const { updatedOrder, beauticians } = this.state;

       // Ensure 'order' is defined before accessing its properties
       if (!order) {
        return <div>Loading...</div>;
      }
  


    return (
        
      <>
      <div style={{backgroundColor:"rgba(74, 104, 57, 0.185)",padding:"15px",width:"350px",border:"3px ridge rgba(103,120,95,1)"}}>
        <div>
        <p style={{textAlign:"center",fontWeight:"bolder",textTransform:"uppercase",color:"rgba(103,120,95,1)",fontFamily:"sans-serif"}}>Sage Salon</p>
       
        <div className="m-0" style={{lineHeight: "15%",fontFamily:"sans-serif",margin:"0px"}}>
          <p  style={{textAlign:"center", fontWeight:"bold",fontSize:"12px"}}>#64 Serangoon Road</p>
          <p  style={{textAlign:"center", fontWeight:"normal",fontSize:"12px",marginBottom:"10px"}}>Singapore 217969</p>
        </div>
     
       
        
      </div>
      <hr  style={{border:"1px dashed black",padding:"0px",margin:"0px"}}/>

     
        <h6 style={{fontWeight:"lighter",color:"black", fontSize:"14px"}} >Booking No:{" "}<b>{order.order_id}</b>
        <span style={{fontSize:"13px", float:"right",letterSpacing:"-1px"}}>{" "}{order.order_date}</span>
      
        </h6>
        <h6 style={{fontWeight:"lighter",color:"black", fontSize:"13px"}}>
        <span style={{fontSize:"13px"}}>staus: {
          order.order_status == 0 ? <span className="badge rounded-pill p-1" style={{backgroundColor:"lightskyblue"}}>Upcoming</span> : order.order_status == 1 ? <span className="badge rounded-pill bg-success p-1">Inprogress</span> : <span className="badge rounded-pill p-1" style={{backgroundColor:"purple"}}>Completed</span> 
          }
          </span>
        </h6>
 <table style={{borderCollapse:"collapse",width:"100%",marginBottom:"10px"}}>

 <thead style={{borderTop:"1px solid rgba(103,120,95,1)",borderBottom:"1px solid rgba(103,120,95,1)",maxWidth:"100%"}}>
 <th style={{padding:"2px",color:"black"}}>SittingType</th>
 <th style={{padding:"2px",color:"black"}}>Beautician</th>
 <th style={{padding:"2px",color:"black"}}>Services</th>
   <th style={{padding:"2px",color:"black"}}>Price</th>
   <th style={{padding:"2px",color:"black"}}></th>
   {/* {(order.order_status == 0 || order.order_status == 1) && <th style={{padding:"2px",color:"black"}}>Action</th>} */}
 </thead>

 <tbody>
  {
    order.services.map((service,index)=>(
      <tr key={index}>
          <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize", fontSize:"12px"}}>{service.type}</td>
          <td style={{padding:"2px",color:"black",textAlign:"center", fontSize:"12px"}}>{service.beautician ? service.beautician : "-"}</td>
      <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize", fontSize:"12px"}}>{service.service_name}</td>
      <td style={{padding:"2px",color:"black",textAlign:"center", fontSize:"12px"}}>{service.service_cost} SGD</td>
      {(order.order_status === 0 || order.order_status === 1) && (
              <td style={{ padding: "2px", color: "black", textAlign: "center", fontSize: "12px" }}>
                <i className="bi bi-pencil-square" style={{ color: "blue", fontSize: "18px" }} onClick={() => this.handleOpenOrderEdit(service)}></i>
              </td>
            )}
    </tr>

    ))

  }
   
  
   {/* <tr>
     <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize"}}>Delux Facial</td>
     <td style={{padding:"2px",color:"black",textAlign:"center"}}>40 SGD</td>
   </tr>
   <tr>
     <td style={{padding:"2px",color:"black",textAlign:"left",textTransform:"capitalize"}}>Skin1</td>
     <td style={{padding:"2px",color:"black",textAlign:"center"}}>10 SGD</td>
   </tr> */}
 
 </tbody>

</table>
<hr style={{border:"1px dashed black",position:"relative",top:"-15px",padding:"0px",marginBottom:"10px"}}/>
        <h6 style={{padding:"1px",color:"rgba(103,120,95,1)",textAlign:"center",fontWeight:"bolder",marginTop:"-20px",fontFamily:"monospace",marginBottom:"-2px"}}><b>Total Amount: {" "}
          {order.total_amount} </b> <span style={{fontSize:"17px"}}>SGD</span></h6>
          <hr style={{border:"1px dashed black",position:"relative",top:"-5px",padding:"0px",marginBottom:"10px"}}/>
          <h6 style={{fontWeight:"lighter",color:"black", fontSize:"13px",lineHeight:"2px"}} >Customer: {order.customer_name}
        <span style={{fontSize:"13px", float:"right",letterSpacing:"-1px"}}>Phone:{order.customer_mobile}</span>
        </h6>
      </div>
      {/* <div className='text-center mt-1'>
      <button className='btn btn-primary'>Print</button>
      </div> */}
      <br/>
      <br/>


      <Modal
        isOpen={this.state.isOpenOrderEdit}
        toggle={this.handleCloseOrderEdit}
        size="lg"
        style={{ overflow: 'visible' }} // Ensuring modal allows overflow
      >
        <ModalHeader closeButton style={{ backgroundColor: "rgba(103, 120, 95, 0.367)", padding: "12px" }}>
          Update Booking
        </ModalHeader>
        <ModalBody>
          <div style={{ padding: "10px" }}></div>
          <div className="card" style={{ maxWidth: "12rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "10px", height: "auto", borderRadius: "15px" }}>
            <div className="card-body">
              <div className="row">
                <div className="col">
                  <h6 style={{ color: "rgba(103, 120, 95)" }}>Booked By:{" "}<b style={{ color: "black" }}>{order.customer_name}</b> </h6>
                </div>
                <div className="col">
                  <h6 style={{ color: "rgba(103, 120, 95)" }}>Mobile: {" "}<b style={{ color: "black" }}>{order.customer_mobile}</b></h6>
                </div>
              </div>
              <hr />
              <div className="d-flex justify-content-center">
                <Accordion>
                  <Accordion.Item eventKey="0" style={{ border: "none" }}>
                    <Accordion.Header>
                      <div className="card" style={{ width: "21rem", margin: "auto", border: "1px solid rgba(103, 120, 95)", padding: "5px", height: "auto", backgroundColor: "rgba(103, 120, 95, 0.367)", borderRadius: "15px", margin: "8px" }}>
                        {updatedOrder && (
                          <div className="card-body">
                            <div className="row align-items-center">
                              <div className="col">
                                <span>{updatedOrder.service_name} <span style={{ float: "right", fontSize: "18px", color: "rgba(103, 120, 95)" }}></span></span>
                                <span style={{ color: "black", fontWeight: "bolder" }}>{updatedOrder.service_cost} SGD</span>
                              </div>
                            </div>
                            <hr />
                            <h6 style={{ fontSize: "13px" }}><b>Duration:</b> {this.convertMinutesToHours(updatedOrder.service_duration)}<span style={{ fontSize: "13px", float: "right" }}><b>Beautician:</b> {updatedOrder.beautician} </span></h6>
                            <h6 style={{ fontSize: "13px" }}><b>Sitting type:</b> {updatedOrder.room_id ? "room" : updatedOrder.seat_id ? "Seat" : "-"} <span style={{ fontSize: "13px", float: "right" }}><b>{updatedOrder.room_id ? "room" : updatedOrder.seat_id ? "Seat" : " "} Name:</b> {updatedOrder.room_id ? (updatedOrder.room_name ? updatedOrder.room_name : "-") : (updatedOrder.seat_name ? updatedOrder.seat_name : "-")} </span></h6>
                            <h6 style={{ fontSize: "13px" }}><b> From Time:</b> {updatedOrder && updatedOrder.start_time ? updatedOrder.start_time : "-"} <span style={{ fontSize: "13px", float: "right" }}><b> To Time:</b> {updatedOrder && updatedOrder.end_time ? updatedOrder.end_time : "-"} </span></h6>
                          </div>
                        )}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      <div style={{ display: 'flex', alignItems: 'center', gap: "10px", margin: "auto" }}>
                        <div>
                          <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>From Time: </label>
                          <input
                            type="time"
                            name="start_time"
                            placeholder="select time"
                            value={updatedOrder && updatedOrder.start_time ? updatedOrder.start_time : ""}
                            onChange={this.handleTimeChange}
                          />
                        </div>
                        <div>
                          <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>To Time: </label>
                          <span>{updatedOrder && updatedOrder.end_time}</span>
                        </div>
                        <label style={{ fontFamily: "serif", fontWeight: "bolder" }}>Beautician: </label>
                        <Select
                            options={beauticians}
                            value={beauticians.find(option => option.value === updatedOrder && updatedOrder.employee_id)}
                            onChange={this.handleBeauticianChange}
                            placeholder="Select Beautician"
                            isSearchable={true}
                            menuPlacement="bottom"
                            styles={{
                              menu: (provided) => ({
                                ...provided,
                                zIndex: 9999,
                                position: 'absolute',
                              }),
                              container: (provided) => ({
                                ...provided,
                                width: '30%',
                              }),
                              control: (provided) => ({
                                ...provided,
                              }),
                            }}
                          />
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <br />
              <br />
              <div className="text-center">
                <button className="btn btn-success" style={{ color: "white", backgroundColor: "rgba(103, 120, 95)", borderColor: "rgba(103, 120, 95)", fontWeight: "normal" }} onClick={this.handleSubmit}>Update</button>
                <br />
                <br />
              </div>
            </div>
          </div>
          <br />
          <button className="btn btn-danger" style={{ fontWeight: "normal", float: "right" }} onClick={this.handleCloseOrderEdit}>Close</button>{' '}
          <Select
            options={beauticians}
            placeholder="Select Order"
            isSearchable={true}
            className="sbcustomSelectFood"
            styles={{
              menu: (provided) => ({
                ...provided,
                zIndex: 9999,
                position: 'absolute',
                overflow: 'visible',
              }),
              control: (provided) => ({
                ...provided,
                overflow: 'visible',
              }),
            }}
          />
        </ModalBody>
      </Modal>
      </>
      
    );
  }
}

export default SbBill;